/**
 *
 * CustomDatePicker
 *
 */
import React from "react";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import styled from "styled-components";

import MomentUtils from "@date-io/moment";
import PropTypes from "prop-types";

const DatePicker = styled(InlineDatePicker)`
  &&& {
    width: 100%;
    label {
      font-size: 20px;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CustomDatePicker extends React.Component {
  render() {
    const { onChange, selectedDate, label, minDate, maxDate } = this.props;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          InputProps={
            {
              // disableUnderline: true
            }
          }
          value={selectedDate}
          onChange={onChange}
          format="DD-MM-YYYY"
          label={label}
          minDate={minDate}
          maxDate={maxDate}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

CustomDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedDate: PropTypes.any,
  label: PropTypes.string.isRequired,
  minDate: PropTypes.any
};

export default CustomDatePicker;



// WEBPACK FOOTER //
// ./src/components/customDatePicker.js